import { BrowserRouter, Switch, Route } from "react-router-dom";
// Constants
import { pathHomePage } from "../config/constants";
// Components
import SignIn from "../views/SignIn";
import Home from "../views/Home";
import Support from "../views/Support";
import AddPatient from "../views/Patient-Add";
import EditPatient from "../views/Patient-Edit";
import DeletedPatient from "../views/Deleted-Patient-From-Orion";
import PrescriptionsClinic from "../views/Prescriptions/clinic";
import PrescriptionsApp from "../views/Prescriptions/app";
import PrescriptionsPlus from "../views/Prescriptions/plus";
import WearReferenceDates from "../views/Wear-Reference-Dates";
import Reports from "../views/Reports";
import SessionGraphics from "../views/Session-Graphics";
import GlobalPatientAdherence from "../views/Global-Patient-Adherence";
import Settings from "../views/Settings";
import FirstLogin from "../views/First-Login";
import AdvancedAnalytics from "../views/Advanced-Analytics";
import PatientMessages from "../views/Patient-Messages";
import CommitmentQuestions from "../views/Commitment-Questions";
import EmotionalQuestions from "../views/Emotional-Questions";
import DiagnosisPrescriptions from "../views/Diagnosis-Prescriptions";
import Recsys from "../views/Recsys";
import RGSICUSessions from "../views/RGS-ICU/sessions";
import RGSICUSessionDetails from "../views/RGS-ICU/sessionDetails";
import RGSICUActivities from "../views/RGS-ICU/activities";
import RGSICUReports from "../views/RGS-ICU/reports";
import RGSICUEvaluations from "../views/RGS-ICU/evaluations";
import RGSICUComparison from "../views/RGS-ICU/comparison";

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path={`/`} component={SignIn} exact />
      <Route path={`${pathHomePage}/home/:clinicianToken`} component={Home} />
      <Route path={`${pathHomePage}/support/:clinicianToken`} component={Support} />
      <Route path={`${pathHomePage}/add-patient/:clinicianToken`} component={AddPatient} />
      <Route path={`${pathHomePage}/edit-patient/:clinicianToken/:patientId`} component={EditPatient} />
      <Route path={`${pathHomePage}/deleted-patient/:clinicianToken`} component={DeletedPatient} />
      <Route path={`${pathHomePage}/prescriptions/clinic/:clinicianToken/:patientId`} component={PrescriptionsClinic} />
      <Route path={`${pathHomePage}/prescriptions/app/:clinicianToken/:patientId`} component={PrescriptionsApp} />
      <Route path={`${pathHomePage}/prescriptions/plus/:clinicianToken/:patientId`} component={PrescriptionsPlus} />
      <Route path={`${pathHomePage}/prescriptions/wear/:clinicianToken/:patientId`} component={WearReferenceDates} />
      <Route path={`${pathHomePage}/prescriptions/icu/:clinicianToken/:patientId`} component={RGSICUSessions} />
      <Route path={`${pathHomePage}/sessions/icu/:clinicianToken/:patientId/:sessionNumber`} component={RGSICUSessionDetails} />
      <Route path={`${pathHomePage}/activities/icu/:clinicianToken/:patientId`} component={RGSICUActivities} />
      <Route path={`${pathHomePage}/reports/icu/:clinicianToken/:patientId/:protocolId`} component={RGSICUReports} />
      <Route path={`${pathHomePage}/evaluations/icu/:clinicianToken/:patientId`} component={RGSICUEvaluations} />
      <Route path={`${pathHomePage}/comparison/icu/:clinicianToken/:patientId`} component={RGSICUComparison} />
      <Route path={`${pathHomePage}/reports/:clinicianToken/:software/:patientId/:protocolId`} component={Reports} />
      <Route
        path={`${pathHomePage}/session-graphics/:clinicianToken/:software/:patientId/:protocolId/:sessionId`}
        component={SessionGraphics}
      />
      <Route path={`${pathHomePage}/global-Patient-Adherence/:clinicianToken/:patientId`} component={GlobalPatientAdherence} />
      <Route path={`${pathHomePage}/settings/:clinicianToken`} component={Settings} />
      <Route path={`${pathHomePage}/validate-password/:clinicianToken`} component={FirstLogin} />
      <Route path={`${pathHomePage}/advanced-analytics/:clinicianToken/:patientId`} component={AdvancedAnalytics} />
      <Route path={`${pathHomePage}/messages/:clinicianToken/:patientId/:software`} component={PatientMessages} />
      <Route path={`${pathHomePage}/commitment-questions/:clinicianToken/:patientId/:software`} component={CommitmentQuestions} />
      <Route path={`${pathHomePage}/emotional-questions/:clinicianToken/:patientId/:software`} component={EmotionalQuestions} />
      <Route path={`${pathHomePage}/diagnosis-prescriptions/:clinicianToken/:patientId/:software`} component={DiagnosisPrescriptions} />
      <Route path={`${pathHomePage}/recsys/:clinicianToken/:patientId`} component={Recsys} />
      {/* redirect user to SignIn page if route does not exist and user is not authenticated */}
      <Route component={SignIn} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
